import { doLogout } from "actions/authAction";
import { BASE_URL } from "actions/constant";
export const YEAR_To_DATE_FETCH_ALL = "YEAR_To_DATE_FETCH_ALL";
export const TRX_BRISTORE_FETCH_ALL = "TRX_BRISTORE_FETCH_ALL";
export const CONTAINER_VOYAGE_FETCH_ALL = "CONTAINER_VOYAGE_FETCH_ALL";
export const RUAS_TRAYEK_FETCH_ALL = "RUAS_TRAYEK_FETCH_ALL";
export const RUAS_TRAYEK_FETCH_ALL_PORTAL = "RUAS_TRAYEK_FETCH_ALL_PORTAL";

const getYearToDataProses = (bool, guest) => {
  return {
    type: YEAR_To_DATE_FETCH_ALL,
    load: bool,
    val: guest.data,
  };
};

const getTrxBristoreProses = (bool, guest) => {
  return {
    type: TRX_BRISTORE_FETCH_ALL,
    load: bool,
    val: guest.data,
  };
};

const getContainerVoyageProses = (bool, guest) => {
  return {
    type: CONTAINER_VOYAGE_FETCH_ALL,
    load: bool,
    val: guest.data,
  };
};
const getRuasTrayekProses = (bool, guest) => {
  return {
    type: RUAS_TRAYEK_FETCH_ALL,
    load: bool,
    val: guest.data,
  };
};
const getRuasTrayekProsesPortal = (bool, data) => {
  return {
    type: RUAS_TRAYEK_FETCH_ALL_PORTAL,
    load: bool,
    val: data.data,
  };
};
export const getYearToData = (data) => {
  return (dispatch) => {
    dispatch(getYearToDataProses(true, { data: {} }));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      if (data === undefined) {
        data = { payment_channel: 1 };
      } else {
        data.payment_channel = 1;
      }
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `/new-dashboard/get-dashboard-yeartodate`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((res) => {
        dispatch(getYearToDataProses(false, res));
      })
      .catch((err) => {
        // console.log(err, 'err cuk')
        dispatch(getYearToDataProses(false, { data: {} }));
      });
  };
};

export const getTrxbristore = (data) => {
  return (dispatch) => {
    dispatch(getTrxBristoreProses(true, { data: [] }));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `/new-dashboard/get-dashboard-bristore`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((res) => {
        dispatch(getTrxBristoreProses(false, res));
      })
      .catch((err) => {
        // console.log(err, 'err cuk')
        dispatch(getTrxBristoreProses(false, { data: [] }));
      });
  };
};

export const getContainerVoyage = (data) => {
  return (dispatch) => {
    dispatch(getContainerVoyageProses(true, { data: {} }));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `new-dashboard/get-dashboard-chart`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((res) => {
        dispatch(getContainerVoyageProses(false, res));
      })
      .catch((err) => {
        // console.log(err, 'err cuk')
        dispatch(getContainerVoyageProses(false, { data: {} }));
      });
  };
};

export const getRuasTrayek = (data) => {
  return (dispatch) => {
    dispatch(getRuasTrayekProses(true, { data: {} }));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `new-dashboard/get-dashboard-ruas-trayek`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((res) => {
        dispatch(getRuasTrayekProses(false, res));
      })
      .catch((err) => {
        // console.log(err, 'err cuk')
        dispatch(getRuasTrayekProses(false, { data: {} }));
      });
  };
};

export const getRuasTrayekPortal = (data) => {
  return (dispatch) => {
    dispatch(getRuasTrayekProsesPortal(true, { data: {} }));

    let config = {};
    config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + `new-dashboard/get-dashboard-ruas-trayek-portal`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((res) => {
        dispatch(getRuasTrayekProsesPortal(false, res));
      })
      .catch((err) => {
        // console.log(err, 'err cuk')
        dispatch(getRuasTrayekProsesPortal(false, { data: {} }));
      });
  };
};
